import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-review',
  templateUrl: './new-review.component.html',
  styles: [
  ]
})
export class NewReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
